// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Pervasives from "../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Router from "next/router";
import * as SEOCmp$PorterinFeature from "../../shared/seo/view/components/SEOCmp.mjs";
import * as FooterCmp$PorterinFeature from "../../shared/footer/view/components/FooterCmp.mjs";
import * as HeaderCmp$PorterinFeature from "../../shared/header/view/components/HeaderCmp.mjs";
import * as LocalStorage$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/helpers/LocalStorage.mjs";
import * as CookieUtils$PorterinFeature from "../../containers/fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as CityProvider$PorterinFeature from "../../contexts/city-context/CityProvider.mjs";
import * as CommonHelper$PorterinFeature from "../../shared/core/helpers/CommonHelper.mjs";
import * as ModalManager$PorterinFeature from "../../contexts/modal-context/ModalManager.mjs";
import * as ModalProvider$PorterinFeature from "../../contexts/modal-context/ModalProvider.mjs";
import * as AuthProviderV1$PorterinFeature from "../../containers/login/view-model/contexts/auth-context/AuthProviderV1.mjs";
import * as AnalyticsHelper$PorterinFeature from "../../shared/core/helpers/AnalyticsHelper.mjs";
import * as MainLayoutHelper$PorterinFeature from "../../containers/fare-estimate-v1/domain/helpers/MainLayoutHelper.mjs";
import * as SelectedCityHook$PorterinFeature from "../../shared/core/hooks/SelectedCityHook.mjs";
import * as FooterViewBindings$PorterinFeature from "../../shared/footer/view/components/FooterViewBindings.mjs";
import * as HeaderViewBindings$PorterinFeature from "../../shared/header/view/components/HeaderViewBindings.mjs";

function MainLayout(Props) {
  var children = Props.children;
  var header_data = Props.header_data;
  var footer_data = Props.footer_data;
  var has_fare_estimate_buttonOpt = Props.has_fare_estimate_button;
  var meta_data = Props.meta_data;
  var show_download_stickyOpt = Props.show_download_sticky;
  var has_fare_estimate_button = has_fare_estimate_buttonOpt !== undefined ? has_fare_estimate_buttonOpt : false;
  var show_download_sticky = show_download_stickyOpt !== undefined ? show_download_stickyOpt : true;
  var match = ModalManager$PorterinFeature.useModal(undefined);
  var toggleModal = match[2];
  var match$1 = SelectedCityHook$PorterinFeature.useCitySelected(undefined);
  var setCitySelected = match$1[1];
  var match$2 = SelectedCityHook$PorterinFeature.useCitySelected(undefined);
  var setCitySelectedLabel = match$2[1];
  var router = Router.useRouter();
  var match$3 = CookieUtils$PorterinFeature.getAuthCookies(undefined);
  var mobile = match$3[2];
  var auth_token = match$3[1];
  var match$4 = React.useState(function () {
        
      });
  var set_user = match$4[1];
  var user = match$4[0];
  var match$5 = React.useState(function () {
        return false;
      });
  var set_is_authenticated = match$5[1];
  var is_authenticated = match$5[0];
  var match$6 = React.useState(function () {
        return /* Init */0;
      });
  var set_is_authenticated_loadable = match$6[1];
  var match$7 = React.useState(function () {
        return /* Init */0;
      });
  var set_order_history = match$7[1];
  var match$8 = React.useState(function () {
        
      });
  var set_agreed_docs = match$8[1];
  React.useEffect((function () {
          LocalStorage$PorterinUtils.getUserCity(function (localStorageCitySelected) {
                Curry._1(setCitySelected, (function (param) {
                        return localStorageCitySelected;
                      }));
                Curry._1(setCitySelectedLabel, (function (param) {
                        return localStorageCitySelected;
                      }));
              });
        }), []);
  var isAuthenticated = function (param) {
    if (auth_token.length > 0) {
      return mobile.length > 0;
    } else {
      return false;
    }
  };
  React.useEffect((function () {
          if (isAuthenticated(undefined)) {
            MainLayoutHelper$PorterinFeature.fetchProfileV2(set_user, user, set_is_authenticated, set_is_authenticated_loadable, (function (param) {
                    MainLayoutHelper$PorterinFeature.fetchOrderHistory(set_order_history);
                  }));
          } else {
            Curry._1(set_is_authenticated, (function (param) {
                    return false;
                  }));
            Curry._1(set_is_authenticated_loadable, (function (param) {
                    return {
                            TAG: /* Live */1,
                            _0: false
                          };
                  }));
          }
        }), [is_authenticated]);
  return React.createElement(React.Fragment, undefined, React.createElement(SEOCmp$PorterinFeature.make, {
                  seo: {
                    title: meta_data.title,
                    meta_description: meta_data.description,
                    local_data: meta_data.schemas,
                    image: meta_data.image,
                    is_no_index: meta_data.is_no_index
                  }
                }), React.createElement(AuthProviderV1$PorterinFeature.Provider.make, {
                  value: {
                    is_authenticated: is_authenticated,
                    set_is_authenticated: (function (is_authenticated) {
                        Curry._1(set_is_authenticated, (function (param) {
                                return is_authenticated;
                              }));
                      }),
                    is_authenticated_loadable: match$6[0],
                    set_is_authenticated_loadable: (function (is_authenticated_loadable) {
                        Curry._1(set_is_authenticated_loadable, (function (param) {
                                return is_authenticated_loadable;
                              }));
                      }),
                    order_history: match$7[0],
                    set_order_history: (function (order_history) {
                        Curry._1(set_order_history, (function (param) {
                                return order_history;
                              }));
                      }),
                    user: user,
                    set_user: (function (user) {
                        Curry._1(set_user, (function (param) {
                                return user;
                              }));
                      }),
                    agreed_docs: match$8[0],
                    set_agreed_docs: (function (docs) {
                        Curry._1(set_agreed_docs, (function (param) {
                                return docs;
                              }));
                      })
                  },
                  children: React.createElement(CityProvider$PorterinFeature.make, {
                        value: {
                          city_selected: match$1[0],
                          selected_city_label: match$2[0],
                          set_city_selected: (function (citySelected, label) {
                              Curry._1(setCitySelected, (function (param) {
                                      return citySelected;
                                    }));
                              Curry._1(setCitySelectedLabel, (function (param) {
                                      return label;
                                    }));
                            }),
                          category: AnalyticsHelper$PorterinFeature.getCategoryName(router),
                          query_params: CommonHelper$PorterinFeature.persistQueryParams(router.asPath, router)
                        },
                        children: React.createElement(ModalProvider$PorterinFeature.make, {
                              value: {
                                modal: match[1],
                                toggleModal: (function (modalState) {
                                    Curry._1(toggleModal, (function (param) {
                                            return modalState;
                                          }));
                                  })
                              },
                              children: React.createElement("div", {
                                    key: router.locale + Pervasives.string_of_bool(is_authenticated)
                                  }, React.createElement(HeaderViewBindings$PorterinFeature.make, {
                                        data: header_data,
                                        show_download_sticky: show_download_sticky
                                      }), children, React.createElement(FooterViewBindings$PorterinFeature.make, {
                                        footer_data: footer_data,
                                        has_fare_estimate_button: has_fare_estimate_button
                                      }), match[0])
                            })
                      })
                }));
}

var isFooterTsEnabled = true;

var isHeaderTsEnabled = true;

var make = MainLayout;

var $$default = MainLayout;

export {
  isFooterTsEnabled ,
  isHeaderTsEnabled ,
  make ,
  $$default ,
  $$default as default,
}
/* react Not a pure module */
